<template>
  <div class="notice_pg">
    <ul class="tab_nav topArea">
      <li :class="{ on: cdDivision === '' }" @click="handleCdDivision('')">
        <a href="#">전체</a>
      </li>
      <li :class="{ on: cdDivision === 'W' }" @click="handleCdDivision('W')">
        <a href="#">일반</a>
      </li>
      <li :class="{ on: cdDivision === 'P' }" @click="handleCdDivision('P')">
        <a href="#">제증명</a>
      </li>
      <li :class="{ on: cdDivision === 'T' }" @click="handleCdDivision('T')">
        <a href="#">타코</a>
      </li>
    </ul>
    <div class="search_box">
      <div class="form">
        <input
          type="search"
          placeholder="제목+내용으로 검색 가능"
          class="text"
          v-model="searchText"
          @keyup.enter="handleSearch"
        />
        <button @click.prevent="handleSearch">
          <img src="@/assets/front/image/ic_search.png" alt="검색" />
        </button>
      </div>
      <!-- 검색시에만 노출(hide 제거) / 검색 안한 상태는 class="hide" -->
      <p :class="{ result: true, hide: currentSearchText === '' }">
        검색결과 <strong>총 {{ firstTotalElements }}건</strong>
      </p>
    </div>
    <ul class="notice_list">
      <!-- class="type01" = 일반 / type02 = 제증명 / type03 = 타코 -->
      <li
        :class="{
          list: true,
          type01: item.cdDivision === '일반',
          type02: item.cdDivision === '제증명',
          type03: item.cdDivision === '타코',
        }"
        v-for="(item, $index) in list"
        :key="$index"
        :data-num="$index + 1"
        @click="detailArticleLink(item)"
      >
        <div class="list_info">
          <div class="category">
            <span>{{ item.cdDivision }}</span>
            <span :class="{ new: true, hide: item.cntSearch > 0 }">NEW</span>
          </div>
          <div class="writer">
            <span>{{ item.dsUserWrite }}</span>
            <span>{{ item.dsDeptWrite }}</span>
            <span>{{ item.dtWrite }}</span>
          </div>
        </div>
        <div class="con">
          <p>{{ item.dsTitle }}</p>
          <div class="thumb" v-if="item.attachmentThumbFile">
            <img :src="item.attachmentThumbFile.fileUrl" alt="" />
            <span class="count"
              >+{{ item.cntFile > 9 ? '9' : item.cntFile }}</span
            >
          </div>
        </div>
      </li>
    </ul>

    <infinite-loading
      ref="infiniteLoading"
      :direction="direction"
      @infinite="infiniteHandler"
    >
      <span slot="no-more"></span>

      <span slot="no-results">
        <li class="no_list">
          <img src="@/assets/front/image/ic_nolist.png" alt="" />
          <p :class="{ hide: currentSearchText === '' }">
            검색어에 일치하는 공지사항이 없습니다.
          </p>
        </li>
      </span>
    </infinite-loading>
    <button class="page_up" v-scroll-to="{ el: '.notice_pg', offset: -100 }">
      <img src="@/assets/front/image/ic_page_up.png" alt="페이지업" />
    </button>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import { mapActions, mapState, mapGetters } from '@common/store/modules/notice';
import * as actions from '@common/store/modules/notice/types';
import * as getters from '@common/store/modules/notice/getters';
export default {
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      direction: 'top',
      infiniteState: null,
      page: 1,
      itemPerPage: 10,
      cdDivision: '',
      searchText: '',
      currentSearchText: '',
      list: [],
      firstTotalElements: 0,
    };
  },
  computed: {
    ...mapGetters({
      items: getters.NOTICES,
      isLoading: getters.NOTICES_ISLOADING,
      totalElements: getters.NOTICES_COUNT,
    }),
  },
  methods: {
    ...mapActions([actions.FETCH_NOTICES_MOBILE]),

    infiniteHandler($state) {
      this.infiniteState = $state;
      var params = {
        cdDivision: this.cdDivision,
        searchText: this.currentSearchText,
        page: this.page,
        size: this.itemsPerPage,
      };
      this[actions.FETCH_NOTICES_MOBILE](params).then(() => {
        this.direction = 'bottom';
        if (this.page == 1) {
          this.list = [];
          this.firstTotalElements = this.totalElements;
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
        if (this.items.length) {
          this.page += 1;
          this.list.push(...this.items);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    manualLoad() {
      //https://peachscript.github.io/vue-infinite-loading/old/#!/getting-started/trigger-manually
      this.page = 1;
      this.list = [];
      this.$nextTick(() => {
        this.infiniteState.reset();
        this.$refs.infiniteLoading.attemptLoad();
      });
    },
    handleCdDivision(cdDivision) {
      this.cdDivision = cdDivision;
      this.currentSearchText = '';
      this.searchText = '';
      this.manualLoad();
    },
    handleSearch() {
      if (this.searchText && this.searchText.trim() !== '') {
        this.currentSearchText = this.searchText;
        this.manualLoad();
      }
    },
    detailArticleLink(item) {
      this.$router.push({
        name: 'Notice.Info',
        params: { yrYYYY: item.yrYYYY, noSeq: item.noSeq },
      });
    },
  },
};
</script>

<style></style>
